<template>
  <div id="app">
		<router-view></router-view>
		<appFooter></appFooter>
  </div>
</template>





<script>


import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
UIkit.use(Icons);

import appFooter from '@/components/Footer'

export default {
	components: {
    appFooter
	}
}

</script>



<style>

body{
	font-family: 'Roboto', sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #2c3e50;
}






@media only screen and (max-width: 1440px) {

	.firstScreen{
		background-image: url(/img/010_1440_2.jpg) !important;
	}

}



@media only screen and (max-width: 1366px) {

	.firstScreen{
		background-image: url(/img/010_1366_2.jpg) !important;
	}

}



@media only screen and (max-width: 768px){

	.firstScreen{
		background-image: url(/img/010_768_2.jpg) !important;
	}

	.utp{
		font-size: 34px !important;
	}

	.titleCont {
		font-size: 16px !important;
	} 

	.footer p {
		font-size: 14px !important;
	}


}



@media only screen and (max-width: 480px){

		.firstScreen{
		background-image: url(/img/010_480_2.jpg) !important;
	}
	
	.utp{
		font-size: 24px !important;
	}

	.wrapUtp p{
		font-size: 15px !important;
	}

	.goDown {
		font-size: 18px;
	}

}





@media only screen and (max-width: 414px){

		.firstScreen{
		background-image: url(/img/010_414_2.jpg) !important;
	}

	.utp{
		font-size: 29px !important;
	}

	.wrapUtp p{
		font-size: 12px !important;
	}

}






@media only screen and (max-width: 375px){

	.firstScreen{
		background-image: url(/img/010_375_2.jpg) !important;
	}

	.utp{
		font-size: 25px !important;
	}

	.wrapUtp p{
		font-size: 12px !important;
	}

	.footer {
		height: 40px;
	}

	.footer p {
		font-size: 12px !important;
	}

}




@media only screen and (max-width: 360px){

	.firstScreen{
		background-image: url(/img/010_320_2.jpg) !important;
	}

	.utp{
		font-size: 25px !important;
	}

	.wrapUtp p{
		font-size: 11px !important;
	}

}


@media only screen and (max-width: 320px){

	.firstScreen{
		background-image: url(/img/010_320_2.jpg) !important;
	}

	.utp{
		font-size: 22px !important;
	}

	.wrapUtp p{
		font-size: 10px !important;
	}

}
</style>
